/*
 * @Description: 
 * @Author: liqin
 * @Date: 2022-01-05 15:46:41
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from "./config";
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)

import less from 'less'
Vue.use(less)

// 全局axios
import Axios from "./Axios";
import '@/iconfont/iconfont.css'
Vue.use(Axios);
// 全局axios
Vue.prototype.baseurl = config.baseurl;
// import axios from 'axios'
// import qs from 'qs'
// Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
// Vue.prototype.qs = qs           //全局注册，使用方法为:this.qs
Vue.config.productionTip = false
store.state.language = localStorage.getItem('LVLIAN_LANGUAGE') || 'cn';
/* eslint-disable no-new */
new Vue({
  router,
  store,
  data() {
    return {
    }
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js